module.exports = __webpack_public_path__ + "img/geoffrey.3f902d34.png";